import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from "@angular/core";
import {FormModalService} from "../../../root/form-modal/form-modal.service";
import {EvaButton} from "../../../shared/eva-button/eva-button";
import {RestrictionsService} from "../restrictions.service";
import {ActivatedRoute} from "@angular/router";
import {NotificationService} from "../../../root/toast/notification.service";
import {GeneralSettingConfig} from "../general-settings/general-setting";
import {FormBuilder, Validators} from "@angular/forms";
import {ErrorMessage} from "../../../shared/sara-input/error-message";
import {GAService} from "../../../root/ga/ga.service";
import {RestrictionsFormValidator} from "../restrictions-form-validator";
import {SaraSelectComponent} from "../../../shared/sara-select/sara-select.component";
import {RentalLength} from "../rental-length-settings/rental-length";

@Component({
    selector: 'modal-general-settings',
    providers: [GAService],
    templateUrl: './modal-general-settings.component.html'
})

export class ModalGeneralSettingsComponent implements OnInit, OnChanges {

    @Input() generalValues: any;
    @Input() openModal: boolean;

    @ViewChild('modalGeneralForm') form;

    @Output() updateGeneralSetting: EventEmitter<any> = new EventEmitter<any>();

    saveButton: EvaButton;
    companyOid: number;
    errors: any;
    selectMinDurationList = this.restrictionsService.getMinDurationList();
    selectRelease = this.restrictionsService.getDaysInAdvanceList();

    modalValues: GeneralSettingConfig;
    selectMaxDurationList;

    private errorMessages = {
        'daysInAdvance': 'common.error.REQUIRED',
        'minRentalLength': 'common.error.REQUIRED',
        'maxRentalLength': 'common.error.REQUIRED'
    };

    constructor(private route:ActivatedRoute, private toast:NotificationService, public _fb: FormBuilder,
                private formModalService: FormModalService, private restrictionsService: RestrictionsService,
                private gaService:GAService){
        this.saveButton = new EvaButton('common.SAVE', '-primary', '-md');
        this.companyOid = route.snapshot.params['id'];
    }

    ngOnInit(){
        this.buildForm();
        this.errors = {};
    }

    bindSelectionToForm(item){
        for (var i in item){
            this.modalValues[i] = item[i];
        }
        this.selectMaxDurationList = this.restrictionsService.getMaxDurationList(this.modalValues.minRentalLength);
    }

    ngOnChanges(changes: SimpleChanges){
        this.modalValues = new GeneralSettingConfig();
        if(this.generalValues) {
            this.bindSelectionToForm(this.generalValues);
        }
        if(!this.openModal){
            this.modalValues = new GeneralSettingConfig();
        }
    }

    getFormModal(){
        return this.formModalService;
    }

    buildForm() {
        this.form = this._fb.group({
            daysInAdvance: ['', [Validators.required]],
            minRentalLength: ['', [Validators.required, RestrictionsFormValidator.positiveValueWrapper]],
            maxRentalLength: ['', [Validators.required, RestrictionsFormValidator.lengthComparator]]
        });
    }

    bindForm(){
        this.form.controls['daysInAdvance'].setValue(this.modalValues.daysInAdvance);
        this.form.controls['minRentalLength'].setValue(this.modalValues.minRentalLength);
        this.form.controls['maxRentalLength'].setValue({minRentalLength: this.modalValues.minRentalLength, maxRentalLength: this.modalValues.maxRentalLength});
    }


    updateCallback(){
        this.bindForm();
        if(this.form.valid) {
            this.restrictionsService.update(this.modalValues, this.companyOid).subscribe((result) => {
                this.gaService.notify("Autos_anticipación_duración", "Editar_configuración_inicial", [this.modalValues.daysInAdvance, this.modalValues.minRentalLength, this.modalValues.maxRentalLength]);
                this.updateGeneralSetting.emit(this.modalValues);
                this.persistCallback();
            });
        }else{
            this.showErrors();
        }
    }

    onRentalLengthChange(rentalLength: RentalLength) {
        this.modalValues.minRentalLength = rentalLength.min;
        this.modalValues.maxRentalLength = rentalLength.max;
    }

    private showErrors() {
        this.errors = {};
        for(var i in this.form.controls){
            if(!this.form.controls[i].valid){
                this.errors[i] = new ErrorMessage('-invalid', this.errorMessages[i]);
            }
        }
    }

    private persistCallback(){
        this.modalValues = new GeneralSettingConfig();
        this.formModalService.hideFormModal(false);
        this.toast.displayToast('restrictions.TITLE','common.confirmationMessage.SUCCESS_SAVE', null, 'INFO');
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/modal-general-settings/modal-general-settings.component.ts